"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var FireSymbol_png_1 = __importDefault(require("./FireSymbol.png"));
;
var sizeLookup = [20, 40, 60, 80, 100];
var IconDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    display: inline-block;\n    height: 45px;\n    width: 45px;\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: ", ";\n"], ["\n    position: relative;\n    display: inline-block;\n    height: 45px;\n    width: 45px;\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: ", ";\n"])), FireSymbol_png_1.default, function (props) { return sizeLookup[props.size] + '%'; });
var FireflyIcon = function (_a) {
    var size = _a.size;
    return React.createElement(IconDiv, { size: size });
};
exports.default = FireflyIcon;
var templateObject_1;
